import React from 'react'

function fmt(v, prefix = '', suffix = '', decimals = 0) {
  if (v == null) return '—'
  return `${prefix}${Number(v).toLocaleString(undefined, { maximumFractionDigits: decimals })}${suffix}`
}

export default function FinancialSummary({ financial }) {
  if (!financial) return null
  const f = financial
  return (
    <div className="card">
      <div className="card__title">Financial Analysis</div>
      <table className="data-table">
        <tbody>
          <tr>
            <td>LCOE</td>
            <td style={{ color: f.lcoe_usd_per_mwh < 60 ? 'var(--score-excellent)' : f.lcoe_usd_per_mwh < 80 ? 'var(--score-moderate)' : 'var(--score-poor)' }}>
              {fmt(f.lcoe_usd_per_mwh, '$', '/MWh', 2)}
            </td>
          </tr>
          <tr>
            <td>IRR</td>
            <td style={{ color: f.irr_pct > 12 ? 'var(--score-excellent)' : f.irr_pct > 8 ? 'var(--score-moderate)' : 'var(--score-poor)' }}>
              {fmt(f.irr_pct, '', '%', 2)}
            </td>
          </tr>
          <tr><td>NPV</td><td>{fmt(f.npv_usd, '$', '', 0)}</td></tr>
          <tr><td>Payback period</td><td>{fmt(f.payback_years, '', ' years', 1)}</td></tr>
          <tr><td>Total CapEx</td><td>{fmt(f.capex_total_usd, '$', '', 0)}</td></tr>
        </tbody>
      </table>
    </div>
  )
}
